import { AudioSectionContainerType, PlaylistIdParams } from './types'

export const getPlaylistId = (
	audioId: number,
	containerId: number,
	containerType: AudioSectionContainerType,
	fileId: number,
): string => `${audioId}_${containerId}_${containerType || ''}_${fileId}`

export const parsePlaylistId = (playlistId: string): PlaylistIdParams => {
	const params = playlistId.split('_')

	return {
		audioId: Number(params[0]),
		containerId: Number(params[1]),
		containerType: params[2] as AudioSectionContainerType,
		fileId: Number(params[3]),
	}
}
